<template>
  <div class="video-handle">
    <span v-if="showCount" class="hot">
      <span>
        <i class="iconfont icon-hot1"></i>
        <b>{{ heatCount || roomCount.heatCount }}</b>
      </span>
      <span>
        <i class="iconfont icon-renshu"></i>
        <b>{{ watchCount || roomCount.watchCount }}</b>
      </span>
    </span>
    <div style="pointer-events: auto;" v-if="isShowDanmu" @click="toggle" class="danmu">
      <i class="iconfont" :class="danmuIcon"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoHandle',
  data() {
    return {
      danmu: true,
      room: $$.module.data.room,
      api: $$.module.interview.$api,
      heatCount: 0,
      watchCount: 0,
      errCount: 0
    };
  },
  computed: {
    isShowDanmu() {
      return (
        this.getByRefurbishName('barrage').refurbishFlg === '0' &&
        this.room.roomSettingContent.roomInfo.liveState === '1' &&
        !this.room.roomSettingContent.roomInfo.liveVideo
      );
    },
    danmuIcon() {
      return this.danmu ? 'icon-dopen' : 'icon-dstop';
    },
    roomCount() {
      return $$.module.data.room.roomCount;
    },
    showCount() {
      return this.getByRefurbishName('peopleNumber').refurbishFlg === '0';
    }
  },
  mounted() {
    this.showCount && this.getRoomStatCount();
  },
  methods: {
    getByRefurbishName(name) {
      return this.room.roomRefurbish.find((data) => data.refurbishName === name);
    },
    toggle() {
      this.danmu = !this.danmu;
      this.$emit('danmakuToggle', this.danmu);
    },
    getRoomStatCount() {
      this.api
        .getRoomStatCount({
          data: {
            roomId: $$.module.data.room.roomId,
            roomType: '1'
          },
          success: (res) => {
            this.heatCount = res.heatCount;
            this.watchCount = res.watchCount;
          }
        })
        .catch(() => {
          this.errCount++;
        })
        .finally(() => {
          if (this.errCount > 3) return;
          setTimeout(() => {
            this.getRoomStatCount();
          }, 5000);
        });
    }
  }
};
</script>
<style lang="less" scoped>
.video-handle {
  pointer-events: none;
  width: 70%;
  height: 100%;
  padding: 12px 12px 36px;
  text-align: right;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
  .hot {
    padding: 4px 8px;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.3);
    color: #fff;
    font-size: 10px;
    > span:first-child {
      margin-right: 8px;
    }
    i,
    b {
      font-size: 10px;
      font-weight: 400;
      margin: 0 2px;
    }
  }
  .danmu {
    position: absolute;
    bottom: 50px;
    right: 16px;
    .iconfont {
      font-size: 22px;
      color: #fff;
    }
  }
}
</style>
